export default __webpack_public_path__ + "static/case-5-name-2f9658816c4c4e3571e8920a70d7c7f6.png";